import React from "react";
import "../../components/Tutorial/Home.Tutorial.css";
import "../../components/Tutorial/Home.Responsive.Tutorial.css";

export const TutorialHairIcon: React.FC = () => {
	return (
		<span>
			<svg
				version="1.1"
				xmlns="http://www.w3.org/2000/svg"
				width="378"
				height="252"
			>
				<path
					d="M0 0 C124.74 0 249.48 0 378 0 C378 83.16 378 166.32 378 252 C253.26 252 128.52 252 0 252 C0 168.84 0 85.68 0 0 Z"
					fill="transparent"
					transform="translate(0,0)"
				/>
				<path
					d="M0 0 C0.556875 -0.680625 1.11375 -1.36125 1.6875 -2.0625 C5.73378018 -5.45262664 8.09684731 -3.94831033 11.5 -0.375 C14.66474597 2.63150868 15.03304131 1.91545201 19 1 C29.47726968 7.88506293 24.59909403 27.15798902 23.5 37.5625 C23.35505104 38.96675382 23.21051655 40.37105049 23.06640625 41.77539062 C22.71499949 45.18403622 22.35942101 48.59219173 22 52 C18.2980288 48.54207836 16.73544076 45.3411349 15.25 40.5625 C15.02957031 39.90701172 14.80914062 39.25152344 14.58203125 38.57617188 C13.41255406 34.9551509 12.7360265 31.80561796 13 28 C12.4423999 28.09087891 11.8847998 28.18175781 11.31030273 28.27539062 C-0.22020402 30.12311436 -11.3107625 31.48480709 -23 31 C-23.09796875 31.66644531 -23.1959375 32.33289063 -23.296875 33.01953125 C-26.53846154 53 -26.53846154 53 -31 53 C-31.64813824 49.00036998 -32.2930924 45.00023264 -32.9375 41 C-33.11990234 39.87464844 -33.30230469 38.74929687 -33.49023438 37.58984375 C-36.14469543 21.08392226 -36.14469543 21.08392226 -36.125 14.0625 C-36.12757812 13.12535156 -36.13015625 12.18820313 -36.1328125 11.22265625 C-35.86124522 6.67789797 -32.82220419 7.91867651 -29 8 C-28.34 5.69 -27.68 3.38 -27 1 C-23.7 1 -20.4 1 -17 1 C-16.34 -0.32 -15.68 -1.64 -15 -3 C-9.2443032 -5.8778484 -4.69922932 -3.66769118 0 0 Z "
					fill="var(--default-face-icon-secondary-color)"
					transform="translate(123,78)"
				/>
			</svg>
		</span>
	);
};

export default TutorialHairIcon;
